import { User } from '../../../services';
import { Avatar } from '../../../shared';

import classes from '../LeaderBoard.module.scss';

interface RenderUserCellArgs {
  user: User;
  rank?: string;
}

export const renderUserCell = ({ user, rank }: RenderUserCellArgs) => {
  const { screenName, avatar } = user;

  return (
    <td>
      <div className={classes['leader-board__table-user']}>
        <Avatar url={avatar?.url} nonClickable />
        <span className={classes['leader-board__table-user-name']}>{screenName}</span>
        {rank && <span className={classes['leader-board__table-user-rank']}>{rank}</span>}
      </div>
    </td>
  );
};
